export function int16ArrayToFloat32Array(int16Array: Int16Array) {
  let l = int16Array.length;
  let float32Array = new Float32Array(l);
  for (let i = 0; i < l; i++) {
    let normalized = int16Array[i] / 32768.0;
    float32Array[i] = Math.max(-1, Math.min(1, normalized));
  }
  return float32Array;
}

export function mergeUint8Arrays(chunks: Uint8Array[]) {
  // Calculate the total length of all chunks
  const totalLength = chunks.reduce((acc, chunk) => acc + chunk.length, 0);

  // Create a new array with total length
  const mergedArray = new Uint8Array(totalLength);

  // Copy each chunk into the merged array
  let offset = 0;
  for (const chunk of chunks) {
    mergedArray.set(chunk, offset);
    offset += chunk.length;
  }

  return mergedArray;
}

export function diffUint8AndInt16Arrays(
  uint8Array: Uint8Array,
  int16Array: Int16Array
) {
  const additions = [];
  const removals = [];
  const changes = [];

  const uint8Length = uint8Array.length;
  const int16Length = int16Array.length * 2; // Each int16 is 2 bytes

  const maxLength = Math.max(uint8Length, int16Length);

  for (let i = 0; i < maxLength; i++) {
    const value1 = uint8Array[i];
    // Getting the equivalent byte from the Int16Array
    const int16Index = Math.floor(i / 2);
    const isHighByte = i % 2 === 1;
    const value2 =
      int16Index < int16Array.length
        ? isHighByte
          ? (int16Array[int16Index] >> 8) & 0xff
          : int16Array[int16Index] & 0xff
        : undefined;

    if (value1 === undefined && value2 !== undefined) {
      additions.push({ index: i, value: value2 });
    } else if (value2 === undefined && value1 !== undefined) {
      removals.push({ index: i, value: value1 });
    } else if (value1 !== value2) {
      changes.push({ index: i, from: value1, to: value2 });
    }
  }

  return { additions, removals, changes };
}

// The duration of the silence introduced by a single zero padding (if required) depends on the sample rate of the audio data.
// Silence Duration (seconds) = 1 / Sample Rate
// so the duration of silence introduced by a single zero padding is approximately 1 / 44,100 seconds, which is roughly 22.7 microseconds for 44.1 kHz audio data: hardly perceptible to the human ear
export function padAudioData(arrayBuffer: ArrayBuffer): Int16Array {
  const uint8Array = new Uint8Array(arrayBuffer);

  // Calculate the number of missing bytes to make it a multiple of 2
  const missingBytes = uint8Array.length % 2 === 1 ? 1 : 0;

  // Create a new Uint8Array with the padded length
  const paddedData = new Uint8Array(uint8Array.length + missingBytes);

  // Copy the original data into the padded array
  paddedData.set(uint8Array);

  // Create an Int16Array from the padded Uint8Array
  const int16Array = new Int16Array(paddedData.buffer);
  if (missingBytes === 1) {
    console.log("Padded audio data with a single zero byte");
    console.log("Padded audio data:", int16Array);
    console.log("unpadded audio data:", arrayBuffer);
  }

  return int16Array;
}

export function ensureEvenLengthInt16Array(
  arrayBuffer: ArrayBuffer
): Int16Array {
  let uint8Array = new Uint8Array(arrayBuffer);

  // If the length is odd, remove the last byte
  if (uint8Array.length % 2 === 1) {
    uint8Array = uint8Array.slice(0, -1);
    console.log("Removed last byte to ensure even length");
  }

  // Create an Int16Array from the Uint8Array
  const int16Array = new Int16Array(uint8Array.buffer);

  return int16Array;
}

export function inspectLast10ValuesInChunks(int16Array: Int16Array) {
  let chunkSize = 10; // Define the size of the chunk to inspect (in this case, 10 values)
  let l = int16Array.length;
  let numberOfChunks = Math.ceil(l / chunkSize);

  for (let i = 0; i < numberOfChunks; i++) {
    // Calculate the start and end indices for the current chunk
    let start = i * chunkSize;
    let end = Math.min(start + chunkSize, l);

    // Extract the last 10 values from the current chunk
    let last10Values = new Int16Array(int16Array.slice(end - chunkSize, end));

    // Log the last 10 values for the current chunk
    console.log(`Chunk ${i + 1} - Last 10 values:`, last10Values);
  }
}
